var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51123 17.83C7.7631 18.1895 8.10598 18.4847 8.50911 18.6889C8.91223 18.8931 9.36298 19 9.8209 19C10.2788 19 10.7296 18.8931 11.1327 18.6889C11.5358 18.4847 11.8787 18.1895 12.1306 17.83",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.725 8.07716V5.95401C14.725 4.64013 14.2272 3.38005 13.3411 2.451C12.455 1.52194 11.2531 1 10 1C8.74685 1 7.54503 1.52194 6.65892 2.451C5.77281 3.38005 5.275 4.64013 5.275 5.95401V8.07716C5.275 10.448 3.25 10.9788 3.25 12.3235C3.25 13.4912 5.84875 14.4466 10 14.4466C14.1513 14.4466 16.75 13.4912 16.75 12.3235C16.75 10.9788 14.725 10.448 14.725 8.07716Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.03591ccc716423d1394348c29b4a1db3.svg";
export { ForwardRef as ReactComponent };